import { 
  Modal, 
  ModalBody, 
  ModalContent, 
  ModalHeader 
} from "@heroui/react"

import { PropTypes } from "prop-types"        

const EmailPreviewModal = ({ 
  handleClose, 
  html, 
  show = false, 
  title 
}) => (
  <Modal
    classNames={{
      backdrop: "z-[99] bg-overlay/75",
      base: "max-h-[85vh] max-w-[686px]",
      body: "p-0",
      header: "bg-indigo-800 rounded-t-xl text-white py-3",
      wrapper: "md:items-center z-[100]",
      closeButton: "hover:bg-white/5 text-white mt-2 mr-2",
      footer: "rounded-b-xl",
    }}
    isDismissable={true}
    isKeyboardDismissDisabled={true}
    isOpen={show}
    onClose={() => handleClose()}
    placement="center"
    radius="lg"
    size="2xl"
    scrollBehavior="inside"
  >
    <ModalContent>
      {(onClose) => (
        <>
          <ModalHeader className="flex flex-col gap-1">{ title }</ModalHeader>

          <ModalBody>
            {html && (
              <div className="email-preview"
                dangerouslySetInnerHTML={{
                  __html: html.replace(/href="([^'"]+)/g, '')
                }}
              />
              )
            }
          </ModalBody>
        </>
      )}
    </ModalContent>
  </Modal>
)

EmailPreviewModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  html: PropTypes.string,
  show: PropTypes.bool,
  title: PropTypes.string.isRequired,
}

export default EmailPreviewModal